import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ModalController } from '@ionic/angular/standalone';
import { StudentService } from './student.service';
import { ProfileValidationService } from './profile-validation.service';
import { ModalBookingBlockedComponent } from '../modals/modal-booking-blocked/modal-booking-blocked.component';

export const BookingGuard: CanActivateFn = async () => {
  const studentService = inject(StudentService);
  const profileValidationService = inject(ProfileValidationService);
  const modalController = inject(ModalController);

  const student = studentService.student;
  const lifeCycle = studentService.getUserLifeCycle(student);

  if (profileValidationService.canBookLessons(student, lifeCycle)) {
    return true;
  }

  const modal = await modalController.create({
    component: ModalBookingBlockedComponent,
    backdropDismiss: true,
  });
  await modal.present();
  await modal.onDidDismiss();
  return false;
};
